export const MetaDataSource = {
  Website: 0,
  MetaTag: 1,
  WhiteLine: 2
}
